import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const MAX_LENGTH = 150;
const SUGGESTION_KEYS = [
  'ai_compare.suggestion_best_value',
  'ai_compare.suggestion_most_features',
  'ai_compare.suggestion_best_quality',
  'ai_compare.suggestion_most_durable',
  'ai_compare.suggestion_best_for_beginners',
];

const ContextInputModal = ({ onBack, onClose, onCompare, selectedLikiees, initialContext }) => {
  const { t } = useTranslation();
  const [context, setContext] = useState(initialContext || '');

  useEffect(() => {
    setContext(initialContext || '');
  }, [initialContext]);

  const handleSuggestion = suggestion => {
    setContext(suggestion);
  };

  const handleSubmit = () => {
    onCompare(context.trim());
  };

  return (
    <div className='ai-compare-modal-overlay' role='dialog' aria-modal='true'>
      <div className='ai-compare-modal'>
        <div className='modal-header'>
          <button type='button' className='back-button' onClick={onBack}>
            {t('ai_compare.back')}
          </button>
          <button
            type='button'
            className='ai-compare-modal__close'
            onClick={onClose}
            aria-label={t('ai_compare.close')}
          >
            ×
          </button>
        </div>

        <h2 className='modal-title'>{t('ai_compare.context_title')}</h2>
        <p className='modal-subtitle'>{t('ai_compare.context_subtitle')}</p>

        <div className='context-input-section'>
          <textarea
            className='context-textarea'
            placeholder={t('ai_compare.context_placeholder')}
            value={context}
            onChange={event => setContext(event.target.value.slice(0, MAX_LENGTH))}
            maxLength={MAX_LENGTH}
          />
          <div className='char-count'>
            {context.length}/{MAX_LENGTH}
          </div>
        </div>

        <div className='suggestions'>
          <p className='suggestions-label'>{t('ai_compare.quick_suggestions')}</p>
          <div className='suggestion-chips'>
            {SUGGESTION_KEYS.map(key => {
              const label = t(key);
              return (
                <button type='button' key={key} className='chip' onClick={() => handleSuggestion(label)}>
                  {label}
                </button>
              );
            })}
          </div>
        </div>

        <div className='modal-footer'>
          <button type='button' className='button-secondary' onClick={() => onCompare('')}>
            {t('ai_compare.skip')}
          </button>
          <button type='button' className='button-primary' onClick={handleSubmit}>
            {t('ai_compare.compare_now')}
          </button>
        </div>
      </div>
    </div>
  );
};

ContextInputModal.propTypes = {
  onBack: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onCompare: PropTypes.func.isRequired,
  selectedLikiees: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ),
  initialContext: PropTypes.string,
};

ContextInputModal.defaultProps = {
  selectedLikiees: [],
  initialContext: '',
};

export default ContextInputModal;
